var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 166,
    height: 215,
    viewBox: "0 0 166 215",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9969_71942)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.2008 177.094C45.7304 163.974 35.0791 137.746 27.3777 141.67C19.6762 145.594 36.9878 164.988 41.6461 178.829",
    fill: "url(#paint0_linear_9969_71942)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M31.3818 147.009C31.3818 147.009 40.9787 165.856 41.7929 172.569",
    stroke: "url(#paint1_linear_9969_71942)",
    strokeWidth: 0.667373,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5612 175.613C38.6429 167.537 13.9501 153.723 10.3863 161.598C6.82257 169.473 32.4631 173.797 44.7561 181.686",
    fill: "url(#paint2_linear_9969_71942)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M15.1379 163.52C24.6013 166.269 42.3534 176.253 42.3534 176.253",
    stroke: "url(#paint3_linear_9969_71942)",
    strokeWidth: 0.667373,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6907 189.294C16.31 192.03 58.7415 187.425 60.2765 190.148C61.8115 192.871 37.439 191.856 31.6462 192.711C25.8534 193.552 24.839 201.907 37.786 201.56C50.7331 201.226 67.7778 199.691 66.0693 202.761C64.3608 205.831 49.1981 204.123 49.8788 209.742C50.5596 215.375 82.4199 213.84 100.319 214C118.205 214.173 122.983 208.047 109.008 206.512C95.0333 204.977 85.3164 204.123 90.9623 202.414C96.595 200.719 153.816 205.311 152.628 197.649C151.44 189.974 132.353 195.767 134.221 192.537C136.103 189.294 163.359 193.391 165.067 185.717C165.762 182.593 143.658 181.205 116.376 180.658C94.5661 180.231 69.4596 180.351 50.0123 180.591C33.982 180.778 21.8091 181.058 18.5256 181.152C6.25931 181.512 5.07138 186.571 10.6907 189.294Z",
    fill: "url(#paint4_linear_9969_71942)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.8789 181.832C50.5596 187.452 82.42 185.917 100.319 186.09C113.306 186.21 119.392 183.007 116.376 180.658C94.5662 180.231 69.4596 180.351 50.0123 180.591C49.8789 180.952 49.8255 181.365 49.8789 181.832Z",
    fill: "url(#paint5_linear_9969_71942)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1548 87.9865L54.23 78.5632L61.9448 80.939L63.7734 84.3427L73.8775 74.8126H81.0317L83.7546 78.9102L87.1715 81.4062L94.0989 78.1094L110.45 81.86L117.844 86.1713V93.3255L100.345 100.48",
    fill: "url(#paint6_linear_9969_71942)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.298 100.48H33.7815C31.9529 100.48 30.6182 98.7446 31.0987 96.9693L33.4879 88.2134C33.8216 87.0121 34.9161 86.1712 36.1707 86.1712H128.909C130.164 86.1712 131.271 87.0121 131.592 88.2134L132.806 92.6448L133.981 96.9693C134.461 98.7446 133.127 100.48 131.298 100.48Z",
    fill: "url(#paint7_linear_9969_71942)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.298 100.48H47.5696L49.1446 94.7003C49.4783 93.4857 50.5728 92.6448 51.8274 92.6448H132.806L133.981 96.9694C134.462 98.7446 133.127 100.48 131.298 100.48Z",
    fill: "url(#paint8_linear_9969_71942)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.295 100.48L121.301 179.243C121.114 181.339 119.366 182.954 117.257 182.954H47.8364C45.7275 182.954 43.9657 181.339 43.7788 179.243L36.7981 100.48H128.295Z",
    fill: "url(#paint9_linear_9969_71942)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.295 100.48L121.301 179.243C121.114 181.339 119.366 182.954 117.257 182.954H83.0471L94.913 100.48H128.295Z",
    fill: "url(#paint10_linear_9969_71942)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4186 126.16C81.6188 126.16 82.126 126.214 82.433 126.748L86.157 133.194L83.5142 134.796C82.6065 135.343 82.6332 136.678 83.5676 137.199L91.0688 141.323C92.0032 141.844 93.1377 141.149 93.1244 140.082L92.9508 131.526C92.9241 130.458 91.7629 129.817 90.8553 130.365L88.4661 131.82L84.7688 125.413C84.0748 124.212 82.8335 123.491 81.4453 123.491C80.0572 123.491 78.8159 124.212 78.1218 125.413L73.3968 133.595C73.0231 134.235 73.25 135.05 73.8907 135.423C74.5313 135.784 75.3455 135.57 75.7193 134.93L80.4443 126.748C80.7513 126.214 81.2585 126.16 81.4587 126.16H81.4186Z",
    fill: "url(#paint11_linear_9969_71942)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.306 151.988L96.381 143.926C95.9939 143.298 95.1797 143.098 94.5524 143.485C93.925 143.872 93.7248 144.687 94.1119 145.314L99.0371 153.376C99.3574 153.896 99.1572 154.377 99.0638 154.55C98.9704 154.724 98.6767 155.151 98.0627 155.164L90.6149 155.338L90.4814 152.255C90.428 151.187 89.2534 150.573 88.3458 151.147L81.1382 155.752C80.2439 156.326 80.2973 157.66 81.2449 158.154L88.8396 162.092C89.7873 162.586 90.9085 161.865 90.8551 160.797L90.735 158.007L98.1295 157.834C99.5176 157.807 100.746 157.046 101.413 155.832C102.08 154.617 102.04 153.176 101.32 151.988H101.306Z",
    fill: "url(#paint12_linear_9969_71942)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.52 155.485L67.07 155.284C66.456 155.284 66.1624 154.857 66.069 154.67C65.9755 154.497 65.7753 154.016 66.0957 153.496L69.9531 147.129L72.6226 148.677C73.5435 149.211 74.7048 148.544 74.7048 147.476V138.92C74.7048 137.853 73.5569 137.185 72.6359 137.719L65.2147 141.99C64.2937 142.524 64.2937 143.859 65.2147 144.393L67.6306 145.794L63.7999 152.121C63.0791 153.309 63.0524 154.751 63.7198 155.965C64.3872 157.18 65.6151 157.927 67.0033 157.954L76.4533 158.154H76.48C77.2007 158.154 77.8014 157.58 77.8147 156.846C77.8281 156.112 77.2408 155.498 76.5067 155.485H76.52Z",
    fill: "url(#paint13_linear_9969_71942)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4186 124.345C81.6188 124.345 82.126 124.398 82.433 124.932L86.157 131.379L83.5142 132.981C82.6065 133.528 82.6332 134.863 83.5676 135.383L91.0688 139.508C92.0032 140.028 93.1377 139.334 93.1244 138.266L92.9508 129.711C92.9241 128.643 91.7629 128.002 90.8553 128.549L88.4661 130.004L84.7688 123.598C84.0748 122.396 82.8335 121.676 81.4453 121.676C80.0572 121.676 78.8159 122.396 78.1218 123.598L73.3968 131.78C73.0231 132.42 73.25 133.234 73.8907 133.608C74.5313 133.969 75.3455 133.755 75.7193 133.114L80.4443 124.932C80.7513 124.398 81.2585 124.345 81.4587 124.345H81.4186Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.306 150.172L96.381 142.11C95.9939 141.483 95.1797 141.283 94.5524 141.67C93.925 142.057 93.7248 142.871 94.1119 143.499L99.0371 151.561C99.3574 152.081 99.1572 152.562 99.0638 152.735C98.9704 152.909 98.6767 153.336 98.0627 153.349L90.6149 153.523L90.4814 150.439C90.428 149.372 89.2534 148.758 88.3458 149.331L81.1382 153.936C80.2439 154.51 80.2973 155.845 81.2449 156.339L88.8396 160.276C89.7873 160.77 90.9085 160.049 90.8551 158.982L90.735 156.192L98.1295 156.019C99.5176 155.992 100.746 155.231 101.413 154.016C102.08 152.802 102.04 151.36 101.32 150.172H101.306Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.52 153.656L67.07 153.456C66.456 153.456 66.1624 153.029 66.069 152.842C65.9755 152.668 65.7753 152.188 66.0957 151.667L69.9531 145.301L72.6226 146.849C73.5435 147.383 74.7048 146.715 74.7048 145.648V137.092C74.7048 136.024 73.5569 135.357 72.6359 135.891L65.2147 140.162C64.2937 140.696 64.2937 142.03 65.2147 142.564L67.6306 143.966L63.7999 150.292C63.0791 151.48 63.0524 152.922 63.7198 154.137C64.3872 155.351 65.6151 156.099 67.0033 156.125L76.4533 156.326H76.48C77.2007 156.326 77.8014 155.752 77.8147 155.017C77.8281 154.283 77.2408 153.669 76.5067 153.656H76.52Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1517 65.0289H10.0366C10.1434 60.3973 14.8818 59.3562 15.9495 61.9856C16.8705 58.4486 19.2197 57.2339 21.1684 57.4742C21.8892 55.9125 22.9436 54.6312 24.1716 54.0039C27.2949 52.4155 32.3536 53.7236 34.0621 60.3706C35.7038 56.3397 42.9782 57.928 43.1517 65.0289Z",
    fill: "url(#paint14_linear_9969_71942)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.8115 11.639H132.927C132.82 7.00743 128.081 5.96633 127.014 8.59578C126.093 5.0587 123.744 3.84408 121.795 4.08433C121.074 2.52268 120.02 1.24132 118.792 0.613991C115.668 -0.974357 110.61 0.333695 108.901 6.98073C107.259 2.9498 99.985 4.53815 99.8115 11.639Z",
    fill: "url(#paint15_linear_9969_71942)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9969_71942",
    x1: 30.7172,
    y1: 135.641,
    x2: 44.7196,
    y2: 190.937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6DE19D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5975AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9969_71942",
    x1: 40.1992,
    y1: 156.659,
    x2: 33.0095,
    y2: 162.874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42363F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#594469"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9969_71942",
    x1: 5.56567,
    y1: 162.135,
    x2: 78.0229,
    y2: 185.622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6DE19D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5975AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9969_71942",
    x1: 33.6508,
    y1: 165.637,
    x2: 23.8659,
    y2: 174.095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42363F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#594469"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_9969_71942",
    x1: 106.873,
    y1: 291.522,
    x2: 69.7399,
    y2: 100.707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9E5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_9969_71942",
    x1: 90.8689,
    y1: 133.021,
    x2: 82.3533,
    y2: 189.254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9E5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_9969_71942",
    x1: 82.9537,
    y1: 72.7704,
    x2: 81.9393,
    y2: 91.8573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFD1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_9969_71942",
    x1: 85.7833,
    y1: 57.8212,
    x2: 78.629,
    y2: 145.728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6DE19D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5975AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_9969_71942",
    x1: 31.7528,
    y1: -6.33995,
    x2: 134.435,
    y2: 174.505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6DE19D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5975AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_9969_71942",
    x1: 78.4422,
    y1: 52.9094,
    x2: 93.0977,
    y2: 222.969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5EFB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95E57D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_9969_71942",
    x1: 22.6899,
    y1: 123.531,
    x2: 107.66,
    y2: 142.164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5EFB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95E57D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_9969_71942",
    x1: 87.0246,
    y1: 109.543,
    x2: 81.8057,
    y2: 146.795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5EFB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95E57D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_9969_71942",
    x1: 97.4354,
    y1: 110.998,
    x2: 92.2032,
    y2: 148.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5EFB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95E57D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_9969_71942",
    x1: 77.0539,
    y1: 108.141,
    x2: 71.8351,
    y2: 145.394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5EFB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95E57D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_9969_71942",
    x1: 24.5186,
    y1: 27.0553,
    x2: 27.4684,
    y2: 81.1259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9E5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_9969_71942",
    x1: 118.445,
    y1: -26.3345,
    x2: 115.481,
    y2: 27.736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9E5FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9969_71942"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 165.12,
    height: 214.08,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/DeleteIcon.fa932036dedf8250bf76c91801cc0dd3.svg";
export { ForwardRef as ReactComponent };